module.exports = __webpack_public_path__ + "static/media/play-store-en.fbb00942.png";